import type { FieldPath, FieldValues } from 'react-hook-form'
import type { Style } from 'inlines'
import { TextInput } from '../../input/text/TextInput'
import { FormField } from '../FormField'
import { useFieldRequired } from '../formSchemaContext'

export type DateFieldProps<T extends FieldValues = FieldValues> = {
  name: FieldPath<T>
  label?: string
  labelStyle?: Style
  required?: boolean
  placeholder?: string
}

export const DateField = <T extends FieldValues = FieldValues>({
  name,
  required,
  ...inputProps
}: DateFieldProps<T>) => {
  const fieldRequired = useFieldRequired(name)
  const isRequired = required ?? fieldRequired

  return (
    <FormField<T>
      name={name}
      render={({ value, onChange, onBlur, errorMessage }) => (
        <TextInput
          {...inputProps}
          required={isRequired}
          inputType="date"
          text={(value as string) ?? ''}
          setText={onChange}
          onBlur={onBlur}
          errorMessage={errorMessage}
        />
      )}
    />
  )
}
